import Openable from './lib/openable';

export default class extends Openable {
  // eslint-disable-next-line class-methods-use-this
  protected getActiveClass() {
    return 'drawer--active';
  }
}
